import React from "react";
import _ from "lodash";

export const ExpansionRegistryContext = React.createContext(null);

export function useExpansionRegistryContext() {
  return React.useContext(ExpansionRegistryContext)
}

export const ChartsSettingsRegistryContext = React.createContext(null);

export function useChartsSettingsRegistryContext() {
  return React.useContext(ChartsSettingsRegistryContext)
}

export class RegistryConfig {
  constructor() {
    this._registry = {};
  }


  set(path, expanded) {
    _.set(this._registry, path, expanded);
  }

  get(path) {
    return _.get(this._registry, path);
  }

  getAll() {
    return this._registry;
  }
}